import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePage } from "../../api/apiPages";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useDeletePage = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    const { mutate: deletePageMutate, isLoading, isPending } = useMutation({
        mutationFn: deletePage,
        onSuccess: () => {
            queryClient.invalidateQueries(['pages']);
            toast.success(isArabic ? "تم حذف الصفحة بنجاح" : "Page deleted successfully");
        },
        onError: (error) => {
            console.error("🚀 ~ useDeletePage ~ error:", error);
            toast.error(isArabic ? "حدث خطأ أثناء حذف الصفحة" : "Error deleting page");
        },
    });

    return { deletePageMutate, isLoading: isLoading || isPending };
};
